import { ISetSubscriptionsFrequencyParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetSubscriptionsFrequencyRequest extends Request<ISetSubscriptionsFrequencyParams, IEmptyResult> {
    constructor(params: ISetSubscriptionsFrequencyParams) {
        super('setSubscriptionsSchedule', params);
    }
}
